import type { IconName } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';

import { Dot, FlexBox, TimeIndicator } from './WelcomeMessage.style';

const messages = defineMessages({
  goodMorning: {
    id: 'welcomeMessage.goodMorning',
    defaultMessage: 'Good morning',
  },
  goodAfternoon: {
    id: 'welcomeMessage.goodAfternoon',
    defaultMessage: 'Good afternoon',
  },
  goodEvening: {
    id: 'welcomeMessage.goodEvening',
    defaultMessage: 'Good evening',
  },
  goodNight: {
    id: 'welcomeMessage.goodNight',
    defaultMessage: 'Good night',
  },
});

export default function WelcomeMessage({ name = '' }: { name: string }) {
  const { formatMessage } = useIntl();

  let message = '';
  let timeIcon: IconName | null = null;
  const date = new Date();
  const hour = date.getHours();

  if (hour < 12 && hour >= 5) {
    message = formatMessage(messages.goodMorning);
    timeIcon = 'sun';
  } else if (hour < 17 && hour >= 12) {
    message = formatMessage(messages.goodAfternoon);
    timeIcon = 'sun';
  } else if (hour < 20 && hour >= 17) {
    message = formatMessage(messages.goodEvening);
    timeIcon = 'moon-stars';
  } else {
    message = formatMessage(messages.goodNight);
    timeIcon = 'moon-stars';
  }

  return (
    <FlexBox>
      <span
        color="textPrimary"
        data-testid="welcome-message"
        className="welcome-msg-start"
      >
        {message}
      </span>
      &nbsp;
      <span data-testid="welcome-message-name" className="welcome-msg-name">
        {name}
      </span>
      <Dot />
      <TimeIndicator>
        <Icon color="warning.main" name={timeIcon} type="fas" />
      </TimeIndicator>
    </FlexBox>
  );
}
